export interface IAppConfig {
  name: string;
}
